export default {
  'breakManagement.title': 'Break & Overtime',
  'breakManagement.tabs.break': 'Break',
  'breakManagement.tabs.overtime': 'Overtime',
  'breakManagement.convertExceedPaidBreakToUnpaid': 'Convert excess time from a paid break to unpaid break',
  'breakManagement.enforceFullTimeUnpaidBreak':
    'Enforce unpaid break by not allowing user to clock in until break time is over',
  'breakManagement.recordOvertime': 'Record overtime and show on the employees’ reports',
  'breakManagement.overtimeThreshold': 'Daily overtime: any hours over the hours entered will count as overtime.',
  'breakManagement.overtimeThreshold.unit': 'hours',
  'breakManagement.breaks.notice': 'Breaks will be considered Unpaid if the restaurant does not set up break types.',

  'breakManagement.column.name': 'Name',
  'breakManagement.column.foreign_name': 'Foreign Name',
  'breakManagement.column.display_name': 'Name',
  'breakManagement.column.type': 'Type',
  'breakManagement.column.duration': 'Duration (mins)',
  'breakManagement.column.active': 'Active',
  'breakManagement.column.action': 'Action',

  'breakManagement.create.title': 'Create Break',
  'breakManagement.edit.title': 'Edit Break',

  'breakManagement.action.create': 'Create New Break',
  'breakManagement.confirmation.deletion': 'Sure to delete the item?',
};
